import { Button, Card, Checkbox, Col, Form, Row, Alert } from 'antd';
import { Link } from 'react-router-dom';
import PageHeading from '../../../../../components/common/PageHeading';
import { useState } from 'react';
import RightBar from '../../../../../components/common/RightBar';
import Footer from '../../../../../components/common/Footer';
import FormAction from '../../../../../components/common/FormAction';
const GeneralSettingsRightBar = [];

const OwnerCommunicationSettings = () => {

    return (<>
        <div className="page-container">
            <div className="main-container">
                <PageHeading heading="Scheduling Settings" />
                <Form layout='vertical'>


                    <Row style={{}} gutter={32}>
                        <Col span={24} >
                            <Checkbox>Allow tenant to submit preferred times on maintenance request</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox>Send a text message reminder to vendors for scheduled work orders</Checkbox>
                        </Col>
                        <Col span={24}>
                            <Checkbox>Send an email to vendors when work orders are scheduled</Checkbox>
                        </Col>
                    </Row>

                    <Row>
                        <Col
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                margin: '20px 0px 0px 0px',
                            }}
                        >
                            <FormAction />
                            </Col>
                    </Row>
                </Form>
                <Footer />

            </div>
        </div>
        <div className="RightSidebar">
            <RightBar RightBarData={GeneralSettingsRightBar} />
        </div>
    </>

    );
};

export default OwnerCommunicationSettings;
